import Link from '@/components/base/TransitionLink';
import SectionLabel from '@/components/feature/SectionLabel';
import { services } from '@/mocks/site';

export default function Expertise() {
  return (
    <section className="tone-white py-20 md:py-28">
      <div className="shell">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-x-6 gap-y-6 mb-12 items-end">
          <div className="md:col-span-3"><SectionLabel index="04">Expertise</SectionLabel></div>
          <h2 data-reveal="title" className="md:col-span-6 md:col-start-4 h-section">What we do</h2>
        </div>
        <ul className="border-t border-foreground-950">
          {services.map((s) => (
            <li key={s.id}>
              <Link
                to="/services"
                className="group grid grid-cols-12 gap-x-6 gap-y-2 py-6 md:py-7 border-b border-background-300 cursor-pointer"
              >
                <span className="col-span-2 md:col-span-3 meta text-accent-600 pt-1.5">{s.number}</span>
                <h3 className="col-span-10 md:col-span-4 font-heading font-medium text-lg md:text-[22px] leading-snug group-hover:text-accent-600 transition-colors">
                  {s.title}
                </h3>
                <p className="col-span-10 col-start-3 md:col-span-4 md:col-start-auto text-sm leading-relaxed text-foreground-700 md:pt-1">{s.short}</p>
                <span className="hidden md:flex col-span-1 justify-end pt-1">
                  <span className="w-5 h-5 flex items-center justify-center"><i className="ri-arrow-right-line text-base transition-transform group-hover:translate-x-1" /></span>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}